import { DataPackageDto, StatusDto } from '@/api/ApiClient';
import type { TreeNode } from '@/types/tree';

/**
 * When a node lives under a data package (or simulation dataset package), returns that package row
 * if it is a **pending** snapshot whose build is **complete** (safe to trim snapshot-only attachments).
 */
export function findAncestorPendingSnapshotDataPackage(
  node: TreeNode,
  getNodeData: (nodeId: string) => TreeNode | null,
  getTypedData: (n: TreeNode) => unknown
): { dataPackageId: number } | null {
  let currentId: string | undefined = node.parentId;

  while (currentId) {
    const parent = getNodeData(currentId);
    if (!parent) {
      break;
    }

    if (parent.type === 'dataPackage' || parent.type === 'simulationDataset') {
      const dp = getTypedData(parent) as DataPackageDto | null | undefined;
      if (!dp?.id) {
        return null;
      }

      const isPendingSnapshot =
        dp.isSnapshot === true &&
        dp.status === StatusDto.Pending &&
        (dp.percentSnapshotDone === undefined || dp.percentSnapshotDone >= 100) &&
        !dp.snapshotInProgress;

      if (!isPendingSnapshot) {
        return null;
      }

      return { dataPackageId: dp.id };
    }

    currentId = parent.parentId;
  }

  return null;
}
